export const apiName: string = 'cidades';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/cidades/shared/data.service.ts
 **/